import { render, staticRenderFns } from "./AddressResultRow.vue?vue&type=template&id=520e3c0c&scoped=true"
import script from "./AddressResultRow.vue?vue&type=script&lang=js"
export * from "./AddressResultRow.vue?vue&type=script&lang=js"
import style0 from "./AddressResultRow.vue?vue&type=style&index=0&id=520e3c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e3c0c",
  null
  
)

export default component.exports